module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content-header",
    staticStyle: {
      "height": "50px"
    }
  }, [(!_vm.$root.isCustomer) ? _c('a', {
    staticStyle: {
      "float": "left",
      "padding-right": "10px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.$root.showNewBox
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle",
    staticStyle: {
      "font-size": "30px"
    }
  })]) : _vm._e(), _vm._v(" "), (0 > 1) ? _c('input', {
    attrs: {
      "type": "button",
      "value": "Get Demo History"
    },
    on: {
      "click": function($event) {
        return _vm.getDemoHistory()
      }
    }
  }) : _vm._e(), _vm._v(" "), (0 > 1) ? _c('input', {
    attrs: {
      "type": "button",
      "value": "Insert Demo History"
    },
    on: {
      "click": function($event) {
        return _vm.insertDemoHistory()
      }
    }
  }) : _vm._e(), _vm._v(" "), (0 > 1 && _vm.$root.isAdmin) ? _c('input', {
    attrs: {
      "type": "button",
      "value": "Fill Toner History"
    },
    on: {
      "click": function($event) {
        return _vm.fillTonerHistory()
      }
    }
  }) : _vm._e(), _vm._v(" "), (10 > 1 && _vm.$root.isAdmin) ? _c('input', {
    attrs: {
      "type": "button",
      "value": "Reset All Printers"
    },
    on: {
      "click": function($event) {
        return _vm.resetAllPrintersAdmin()
      }
    }
  }) : _vm._e(), _vm._v(" "), (0 > 1 && _vm.$root.isAdmin) ? _c('input', {
    attrs: {
      "type": "button",
      "value": "Reset Current Printers"
    },
    on: {
      "click": function($event) {
        return _vm.resetCurrentPrinters()
      }
    }
  }) : _vm._e(), _vm._v(" "), (0 > 1) ? _c('input', {
    attrs: {
      "type": "button",
      "value": "Refresh All Printers"
    },
    on: {
      "click": function($event) {
        return _vm.refreshAllPrintersAdmin()
      }
    }
  }) : _vm._e(), _vm._v(" "), (0 > 1) ? _c('input', {
    attrs: {
      "type": "button",
      "value": "Clear Pending Alerts"
    },
    on: {
      "click": function($event) {
        return _vm.clearPendingAlerts()
      }
    }
  }) : _vm._e(), _vm._v(" "), (0 > 1) ? _c('input', {
    attrs: {
      "type": "button",
      "value": "Copy One Printer From History"
    },
    on: {
      "click": function($event) {
        return _vm.copyPrintersFromRT_HistoryToFirestore()
      }
    }
  }) : _vm._e(), _vm._v(" "), (0 > 1) ? _c('input', {
    attrs: {
      "type": "button",
      "value": "Get Printers From History"
    },
    on: {
      "click": function($event) {
        return _vm.getPrintersFromRT_History()
      }
    }
  }) : _vm._e(), _vm._v(" "), (0 > 1) ? _c('input', {
    attrs: {
      "type": "button",
      "value": "Copy One Printer From RT_Printers To Store_Printers"
    },
    on: {
      "click": function($event) {
        return _vm.copyPrintersFromRT_PrintersToStore_Printers()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('h1', {
    staticStyle: {
      "float": "left",
      "padding-right": "10px"
    }
  }, [_vm._v(_vm._s(_vm.$root.title))]), _vm._v(" "), (_vm.hasData) ? _c('a', {
    staticStyle: {
      "float": "left",
      "padding": "5px 10px"
    },
    attrs: {
      "title": "Export CSV file",
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.exportCSV()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    staticStyle: {
      "font-size": "20px"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.titleCustomerSite) ? _c('h1', {
    staticStyle: {
      "float": "left",
      "padding-right": "10px"
    }
  }, [_vm._v("(" + _vm._s(_vm.titleCustomerSite) + ")")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showDefault),
      expression: "!showDefault"
    }],
    staticClass: "sidebar-form",
    staticStyle: {
      "width": "200px",
      "border-radius": "3px",
      "float": "right",
      "margin": "0px",
      "border": "1px solid #337ab7"
    },
    attrs: {
      "action": "#",
      "method": "get"
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$root.txtSearch),
      expression: "$root.txtSearch"
    }],
    staticClass: "form-control",
    staticStyle: {
      "box-shadow": "none",
      "height": "27px",
      "background-color": "#fff"
    },
    attrs: {
      "type": "text",
      "name": "q",
      "placeholder": "Search..."
    },
    domProps: {
      "value": (_vm.$root.txtSearch)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$root, "txtSearch", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showDefault),
      expression: "!showDefault"
    }],
    class: ['box-tools', _vm.$root.device.isMobile ? 'tabsMobile' : ''],
    staticStyle: {
      "float": "right",
      "padding": "0px 10px"
    }
  }, [_c('ul', {
    staticClass: "pagination pagination-sm inline",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [(!_vm.$root.device.isMobile) ? _c('li', {
    class: [_vm.options.activeFilter === 'All' ? 'active' : '']
  }, [_c('a', {
    staticStyle: {
      "width": "80px!important",
      "text-align": "center"
    },
    on: {
      "click": function($event) {
        _vm.options.activeFilter = 'All'
      }
    }
  }, [_vm._v("All")])]) : _vm._e(), _vm._v(" "), _c('li', {
    class: [_vm.options.activeFilter === 'Toners' ? 'active' : '']
  }, [_c('a', {
    staticStyle: {
      "width": "80px!important",
      "text-align": "center"
    },
    on: {
      "click": function($event) {
        _vm.options.activeFilter = 'Toners'
      }
    }
  }, [_vm._v("Toners")])]), _vm._v(" "), _c('li', {
    class: [_vm.options.activeFilter === 'Counters' ? 'active' : '']
  }, [_c('a', {
    staticStyle: {
      "width": "80px!important",
      "text-align": "center"
    },
    on: {
      "click": function($event) {
        _vm.options.activeFilter = 'Counters'
      }
    }
  }, [_vm._v("Counters")])]), _vm._v(" "), _c('li', {
    class: [_vm.options.activeFilter === 'Info' ? 'active' : '']
  }, [_c('a', {
    staticStyle: {
      "width": "80px!important",
      "text-align": "center"
    },
    on: {
      "click": function($event) {
        _vm.options.activeFilter = 'Info'
      }
    }
  }, [_vm._v("Info")])]), _vm._v(" "), _c('li', {
    class: [_vm.options.activeFilter === 'Deleted' ? 'active' : '']
  }, [_c('a', {
    staticStyle: {
      "width": "80px!important",
      "text-align": "center"
    },
    on: {
      "click": function($event) {
        _vm.options.activeFilter = 'Deleted'
      }
    }
  }, [_vm._v("Deleted")])]), _vm._v(" "), (0 > 1) ? _c('li', {
    class: [_vm.options.activeFilter === 'TonerHistory' ? 'active' : '']
  }, [_c('a', {
    staticStyle: {
      "width": "100px!important",
      "text-align": "center"
    },
    on: {
      "click": function($event) {
        _vm.options.activeFilter = 'TonerHistory'
      }
    }
  }, [_vm._v("Toner History")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "table-responsive",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('va-box', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDefault),
      expression: "showDefault"
    }],
    attrs: {
      "title": "Statistics",
      "theme": "box-info",
      "isLoading": _vm.isLoading,
      "isBorder": true,
      "widgetType": ""
    }
  }, [_c('div', {
    staticStyle: {
      "min-height": "350px",
      "height": "100%",
      "padding": "10px"
    },
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('va-alert', {
    attrs: {
      "type": "warning"
    }
  }, [_c('h4', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('i', {
    staticClass: "icon fa fa-warning"
  }), _vm._v(" Please select Customer/Site from the side menu, to view printers !\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-1 col-md-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Info")])]), _vm._v(" "), _c('row', [_c('va-info-box', {
    attrs: {
      "bgColor": "bg-green",
      "bgIcon": "ion ion-ios-printer-outline",
      "text": "Total Printers",
      "number": _vm.$root.dashData.TotalPrinters,
      "moreText": "All Printers"
    },
    on: {
      "more-click": function($event) {
        _vm.showAllPrinters = true
      }
    }
  })], 1), _vm._v(" "), _c('row', [_c('va-info-box', {
    attrs: {
      "bgColor": "bg-green",
      "bgIcon": "ion-stats-bars",
      "text": "Total Sites",
      "number": _vm.$root.dashData.TotalSites,
      "moreText": "All Sites"
    },
    on: {
      "more-click": function($event) {
        return _vm.$root.goto('Sites')
      }
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-1 col-md-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5 col-md-5"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.$root.showStatuses = !_vm.$root.showStatuses
      }
    }
  }, [_c('strong', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("Printers Status")])])]), _vm._v(" "), _c('div', {
    staticClass: "progress-group",
    on: {
      "click": function($event) {
        return _vm.$root.goto('PrintersOnline')
      }
    }
  }, [_c('span', {
    staticClass: "progress-text"
  }, [_vm._v("Online")]), _vm._v(" "), _c('span', {
    staticClass: "progress-number"
  }, [_c('b', [_vm._v(_vm._s(_vm.$root.dashData.PrintersStatus ? _vm.$root.dashData.PrintersStatus.TotalOnline : 0))]), _vm._v("/" + _vm._s(_vm.$root.dashData.TotalPrinters))]), _vm._v(" "), _c('div', {
    staticClass: "progress sm"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-green",
    style: ({
      width: _vm.$root.calcPercent(_vm.$root.dashData.PrintersStatus ? _vm.$root.dashData.PrintersStatus.TotalOnline : 0, _vm.$root.dashData.TotalPrinters)
    })
  })])]), _vm._v(" "), _c('div', {
    staticClass: "progress-group",
    on: {
      "click": function($event) {
        return _vm.$root.goto('PrintersOffline')
      }
    }
  }, [_c('span', {
    staticClass: "progress-text"
  }, [_vm._v("Offline")]), _vm._v(" "), _c('span', {
    staticClass: "progress-number"
  }, [_c('b', [_vm._v(_vm._s(_vm.$root.dashData.PrintersStatus ? _vm.$root.dashData.PrintersStatus.TotalOffline : 0))]), _vm._v("/" + _vm._s(_vm.$root.dashData.TotalPrinters))]), _vm._v(" "), _c('div', {
    staticClass: "progress sm"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-red",
    style: ({
      width: _vm.$root.calcPercent(_vm.$root.dashData.PrintersStatus ? _vm.$root.dashData.PrintersStatus.TotalOffline : 0, _vm.$root.dashData.TotalPrinters)
    })
  })])]), _vm._v(" "), _c('div', {
    staticClass: "progress-group",
    on: {
      "click": function($event) {
        return _vm.$root.goto('PrintersOutOfPaper')
      }
    }
  }, [_c('span', {
    staticClass: "progress-text"
  }, [_vm._v("Out of Paper")]), _vm._v(" "), _c('span', {
    staticClass: "progress-number"
  }, [_c('b', [_vm._v(_vm._s(_vm.$root.dashData.PrintersStatus ? _vm.$root.dashData.PrintersStatus.TotalOutPaper : 0))]), _vm._v("/" + _vm._s(_vm.$root.dashData.TotalPrinters))]), _vm._v(" "), _c('div', {
    staticClass: "progress sm"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-aqua",
    style: ({
      width: _vm.$root.calcPercent(_vm.$root.dashData.PrintersStatus ? _vm.$root.dashData.PrintersStatus.TotalOutPaper : 0, _vm.$root.dashData.TotalPrinters)
    })
  })])]), _vm._v(" "), _c('div', {
    staticClass: "progress-group",
    on: {
      "click": function($event) {
        return _vm.$root.goto('PrintersLowToner')
      }
    }
  }, [_c('span', {
    staticClass: "progress-text"
  }, [_vm._v("Low Toner")]), _vm._v(" "), _c('span', {
    staticClass: "progress-number"
  }, [_c('b', [_vm._v(_vm._s(_vm.$root.dashData.PrintersStatus ? _vm.$root.dashData.PrintersStatus.TotalOutToner : 0))]), _vm._v("/" + _vm._s(_vm.$root.dashData.TotalPrinters))]), _vm._v(" "), _c('div', {
    staticClass: "progress sm"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-aqua",
    style: ({
      width: _vm.$root.dashData.PrintersStatusPercent.TotalOutToner
    })
  })])]), _vm._v(" "), _c('div', {
    staticClass: "progress-group",
    on: {
      "click": function($event) {
        return _vm.$root.goto('PrintersErrors')
      }
    }
  }, [_c('span', {
    staticClass: "progress-text"
  }, [_vm._v("Errors")]), _vm._v(" "), _c('span', {
    staticClass: "progress-number"
  }, [_c('b', [_vm._v(_vm._s(_vm.$root.dashData.PrintersStatus ? _vm.$root.dashData.PrintersStatus.TotalError : 0))]), _vm._v("/" + _vm._s(_vm.$root.dashData.TotalPrinters))]), _vm._v(" "), _c('div', {
    staticClass: "progress sm"
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-yellow",
    style: ({
      width: _vm.$root.calcPercent(_vm.$root.dashData.PrintersStatus ? _vm.$root.dashData.PrintersStatus.TotalError : 0, _vm.$root.dashData.TotalPrinters)
    })
  })])])])], 1)]), _vm._v(" "), _c('VueTable', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showDefault && !_vm.showDeleted),
      expression: "!showDefault && !showDeleted"
    }],
    attrs: {
      "isLoading": _vm.isLoading,
      "columns": _vm.columns,
      "info": _vm.infoIcons,
      "rows": _vm.filteredItems,
      "pageSize": _vm.pageSize,
      "options": _vm.options
    },
    on: {
      "rowClick": _vm.rowClick,
      "headerClick": _vm.headerClick
    }
  }), _vm._v(" "), _c('VueTable', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showDefault && _vm.showDeleted),
      expression: "!showDefault && showDeleted"
    }],
    attrs: {
      "isLoading": _vm.isLoading,
      "columns": _vm.columnsDeleted,
      "info": _vm.infoIcons,
      "rows": _vm.filteredDeletedItems,
      "pageSize": _vm.pageSize,
      "options": _vm.options
    },
    on: {
      "rowClick": _vm.rowClick,
      "headerClick": _vm.headerClick
    }
  })], 1)]), _vm._v(" "), _c('AddPrinter')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-btn"
  }, [_c('div', {
    staticClass: "btn btn-flat",
    staticStyle: {
      "height": "28px",
      "padding": "4px 6px",
      "background-color": "#fff"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9a635bfc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Printers.vue
// module id = 740
// module chunks = 0